import { Controller } from '@hotwired/stimulus'
import { turboRequest } from '../../helpers/turbo_helper'
import { closeModal } from 'controllers/shared/modals/close_modal_controller.js'

export default class extends Controller {
  static values = {
    selectPersonUrl: String,
    personAttributesPath: Array,
    submittedPhone: String
  }

  connect() {
    this.nextTarget = document.getElementById('next-button')
    this.modal = document.getElementById('modal')

    if (this.modal && this.nextTarget) {
      this.nextTarget.disabled = true;
      this.modal.addEventListener('hidden.bs.modal', this.enableNextTarget)
    }
  }

  disconnect() {
    if(this.modal && this.nextTarget) {
      this.modal.removeEventListener('autocomplete.change', this.enableNextTarget)
    }
  }

  enableNextTarget (event) {
    this.nextTarget = document.getElementById('next-button')
    if (this.nextTarget) {
      this.nextTarget.disabled = false;
    }
  }

  useThisPerson(event) {
    const personId = event.currentTarget.dataset.personId

    var url = new URL(this.selectPersonUrlValue)
    var params = new URLSearchParams(url.search)
    params.append('person_id', personId)
    if (this.submittedPhoneValue) {
      params.append('submitted_phone', this.submittedPhoneValue)
    }

    turboRequest(`${url.pathname}?${params}`)

    closeModal('#modal')
  }

  ignoreDuplicatePersonModalWarning() {
    closeModal('#modal')

    this.updateBypassDuplicatePersonDetectionHiddenField()
  }

  _toRailsName(parts) {
    const clean = (parts || []).filter(p => p != null && p !== '');
    if (clean.length === 0) return '';
    const [head, ...rest] = clean;
    return head + rest.map(p => `[${p}]`).join('');
  }

  updateBypassDuplicatePersonDetectionHiddenField() {
    // Construct the name attribute
    var nameAttribute = `${this._toRailsName(this.personAttributesPathValue)}[bypass_duplicate_person_detection]`
    var forms = document.querySelectorAll('form')
    var form = forms[forms.length - 1]
    var existingInput = form.querySelector(`input[name="${nameAttribute}"]`)

    if (!existingInput) {
      var hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', nameAttribute)
      hiddenInput.setAttribute('value', true)
      form.appendChild(hiddenInput)
    } else {
      existingInput.value = true
    }

    form.submit()
  }
}
